<mat-dialog-actions fxLayout="column" fxLayoutGap="10px">
    <button
        [id]="'button_courses-must-review_FazerReview'"
        mat-flat-button
        color="primary"
        type="button"
        [mat-dialog-close]="true"
    >
        {{ "VIEWER.TABS.MUST_REVIEW.NOW" | translate }}
    </button>
    <button
        [id]="'button_courses-must-review_NaoFazerReview'"
        mat-stroked-button
        color="primary"
        type="button"
        [mat-dialog-close]="false"
    >
        {{ "VIEWER.TABS.MUST_REVIEW.NOT_NOW" | translate }}
    </button>
</mat-dialog-actions>
